// Relative paths, not the "@assets" alias -- same reasoning as flameBadgeArt.ts and rewardArtwork.ts:
// "@assets/*" isn't in jest's moduleNameMapper, and this module's test needs the real imports. One
// static import per file (never a dynamic `require`) so webpack fingerprints every asset.
import tenure1y from "../../../../assets/images/tenureBadges/tenure-1y.png";
import tenure2y from "../../../../assets/images/tenureBadges/tenure-2y.png";
import tenure3y from "../../../../assets/images/tenureBadges/tenure-3y.png";
import tenure5y from "../../../../assets/images/tenureBadges/tenure-5y.png";
import tenure7y from "../../../../assets/images/tenureBadges/tenure-7y.png";

/**
 * Bundled tenure badge artwork (176x176 PNG, transparent), keyed by the api's own EXACT
 * `badge_definitions.code` (api `migrations/20260807090100_Insert-BadgeDefinitions-FlameTenure.js`).
 *
 * Keyed on the code verbatim, like `flameBadgeArt.ts`: tenure codes are static strings, identical in
 * every environment. The code names the YEARS (`tenure_5y`), not the ladder position -- the api's `tier`
 * for `tenure_5y` is 4, because the ladder skips 4 and 6 years -- so the files are named by years too,
 * and each one has its year count printed on the art itself (Figma `Tenure_L`, `9655:1267`).
 */
const TENURE_BADGE_ART: Record<string, string> = {
  tenure_1y: tenure1y,
  tenure_2y: tenure2y,
  tenure_3y: tenure3y,
  tenure_5y: tenure5y,
  tenure_7y: tenure7y,
};

/**
 * Resolves a tenure badge's `code` to its bundled artwork, or `null` for any code that is not one of
 * the five tenure codes. Never throws. `hasOwnProperty` for the same reason as `resolveFlameBadgeArt`:
 * a bare index would hand back inherited `Object.prototype` members for codes like `"constructor"`.
 *
 * @param code - a badge's own `code`, e.g. `"tenure_5y"`.
 * @returns the bundled asset URL, or `null`.
 */
export const resolveTenureBadgeArt = (code: string): string | null =>
  Object.prototype.hasOwnProperty.call(TENURE_BADGE_ART, code) ? TENURE_BADGE_ART[code] : null;
